export enum ErrorCodesEnumeration {
  CARD = 'card',
  DEFAULT = 'default',
  ME = 'me',
  TRANSLATIONS = 'translations',
  UNKNOWN = 'unknown',
}

export enum ErrorDynamicLayoutEnumeration {
  DEFAULT = 'DEFAULT',
  GENERIC_SECTION_ERROR = 'GENERIC_SECTION_ERROR',
}
